(() => {
  // Disabled on Direct Hotel Supplies: the theme now uses the dedicated dhs-search component.
  // Keeping this asset as a no-op prevents the legacy .codex-search-panel from overlapping results.
  window.__codexSearchRecommendations = true;
})();